import { createAsyncThunk } from "@reduxjs/toolkit";
import { openToast } from "store/slices/common/toast.slice";
import {
  addReview,
  deleteReview,
  getReview,
  updateReview,
} from "store/services/reviews";
import { getApiMessage } from "utils/apiErrorCode";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { uploadFile } from "store/services/utilities";

//Get Reviews
export const GetReviewsAction = createAsyncThunk(
  "reviews/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getReview(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete Reviews
export const DeleteReviewsAction = createAsyncThunk(
  "reviews/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteReview(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());

        const responce = await getReview(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//add Reviews
export const AddReviewsAction = createAsyncThunk(
  "reviews/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { first_name, last_name, file, filter, onSuccess, onError, ...rest } =
      payload;
    try {
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }

      const res = await addReview(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());
        if (onSuccess) onSuccess();
        const responce = await getReview(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);

export const UpdateReviewAction = createAsyncThunk(
  "reviews/update",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateReview(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const response = await getReview({ status: filter.status });
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      if (onError) onError();
      return rejectWithValue(res);
    } catch (error) {
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);
